<template>
    <b-card no-body bg-variant="dark" style="min-width: 300px;" class="mb-3">
        <b-card-header>
            <h4>
                {{ app.system }}
            </h4>
        </b-card-header>
        <b-card-body>
            <h1>{{ app.method }}</h1>
            <p class="mt-3">{{ app.instructions }}</p>
            <div class="mt-3">
                <div v-if="app.alternative">
                    <p>
                        Alternatively, download the {{ app.alternative }} file
                        from us.
                    </p>
                    <b-button
                        :href="'/api/files/' + app.alternativeLink"
                        variant="outline-warning"
                    >
                        Download File
                    </b-button>
                </div>
                <p v-else>No alternative methods are available.</p>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button
                block
                :href="app.link || 'https://www.wireguard.com/install'"
                variant="primary"
            >
                Go to official website
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
    export default {
        props: ['app']
    }
</script>